import Joi from "joi";
import axios from "axios";
import Swal from "sweetalert2";
import {
  EMAIL_SCHEMA,
  NAME_SCHEMA,
  PASSWORD_SCHEMA,
  SET_CONFIGURATION,
  SET_EMAIL,
  SET_ERRORS,
  SET_LAYOUT,
  SET_NAME,
  SET_OPERATION_COUNTRY,
  SET_REGISTRATION_TOKEN,
  SET_PASSWORD,
  SET_STAGE,
  SET_STRIPE_PAYMENT_METHOD_ID,
  SET_PACKAGE_PRICE_FROM_RESPONSE,
  SET_STRIPE_REDIRECT
} from "./constants";
import {getOperationCountrySchema} from "./methods";

export default {
  setLayout: ({ commit }, layout) => commit(SET_LAYOUT, layout),
  setConfiguration: ({ commit }, configuration) => commit(SET_CONFIGURATION, configuration),
  setName: ({ commit }, name) => commit(SET_NAME, name),
  setEmail: ({ commit }, email) => commit(SET_EMAIL, email),
  setPassword: ({ commit }, password) => commit(SET_PASSWORD, password),
  setOperationCountry({ commit, state }, payload) {
    const { value } = payload;
    commit(SET_OPERATION_COUNTRY, payload);
    commit(SET_CONFIGURATION, {
      ...state.configuration,
      currency: value === 'United Kingdom' ? 'GBP' : 'USD',
    });
  },
  submitCustomerForm({ state }, countries) {
    state.errors = {};
    const { name, email, password, operationCountry } = state;

    return new Promise((resolve, reject) => {
      const customerFormSchema = Joi.object({
        name: NAME_SCHEMA,
        email: EMAIL_SCHEMA,
        password: PASSWORD_SCHEMA,
        operationCountry: getOperationCountrySchema(countries),
      });

      const {error} = customerFormSchema.validate({
        name,
        email,
        password,
        operationCountry,
      }, {abortEarly: false});

      if (error) {
        error.details.forEach(error => {
          state.errors[error.path[0]] = [error];
        });
        reject();
      }

      axios.post('/ajax/register/validate', {
        name,
        email,
        password,
        operation_country: state.operationCountry
      }).then(response => {
        resolve(response);
      }).catch(({ response }) => {
        reject(response);
      });
    });
  },
  setErrors: ({ commit }, errors) => commit(SET_ERRORS, errors),
  setStage: ({ commit }, stage) => commit(SET_STAGE, stage),
  async getPackagePrice({commit, state}) {
    const {
      currency,
      billingPeriod,
      packageName,
      discount,
    } = state.configuration;

    const {operationCountry} = state;

    try {
      const {data} = await axios.post('/ajax/v2/billing/packages/price', {
        package: packageName,
        currency,
        billingPeriod,
        operationCountry,
        discount,
      });

      commit(SET_PACKAGE_PRICE_FROM_RESPONSE, data.data);
    } catch ({response}) {
      const {data, status} = response;

      let newConfiguration = {
        ...state.configuration,
        billingPeriod: data.billingPeriod,
        currency: data.currency,
      };

      if (status === 404) {
        Swal.fire({
          type: 'error',
          text: data.message,
        });

        commit(SET_CONFIGURATION, newConfiguration);
        commit(SET_PACKAGE_PRICE_FROM_RESPONSE, data);
      }

      if (status === 500) {
        Swal.fire({
          type: 'error',
          html: data.message,
          allowOutsideClick: false,
        }).then(() => {
          window.location.href = '/register';
        });
      }
    }
  },
  async toggleBillingPeriod({ commit, state }) {
    const { billingPeriod: currentBillingPeriod } = state.configuration;
    const configuration = {
      ...state.configuration,
      billingPeriod: currentBillingPeriod === 'YEAR' ? 'MONTH' : 'YEAR',
    };
    await commit(SET_CONFIGURATION, configuration);
  },
  setStripePaymentMethodId: ({ commit }, stripePaymentMethodId) => commit(
    SET_STRIPE_PAYMENT_METHOD_ID,
    stripePaymentMethodId
  ),
  setRegistrationToken: ({ commit }, registrationToken) => commit(SET_REGISTRATION_TOKEN, registrationToken),
  setStripeRedirect: ({ commit }, stripeRedirect) => commit(SET_STRIPE_REDIRECT, stripeRedirect),
};
